import { api } from "@/lib/api";
import type { ProviderConnection, StepProvider } from "@/types";

export async function getProviderConnections(): Promise<ProviderConnection[]> {
  const res = await api.get<ProviderConnection[]>("/provider-connections");
  if (res.error) return [];
  return res.data ?? [];
}

export function hasConnectedProvider(connections: ProviderConnection[]): boolean {
  return connections.some((c) => c.status === "connected");
}

export function getConnectedProviders(connections: ProviderConnection[]): StepProvider[] {
  return connections.filter((c) => c.status === "connected").map((c) => c.provider);
}
